import {
  ComboFilterKeys,
  ComboListFilterOpts
} from "@saleor/combos/components/ComboListPage/filters";
import { maybe, parseBoolean } from "@saleor/misc";
import { ComboFilterInput } from "@saleor/types/globalTypes";

import { IFilterElement } from "../../../components/Filter";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleValueQueryParam
} from "../../../utils/filters";
import {
  ComboListUrlFilters,
  ComboListUrlFiltersEnum,
  ComboListUrlQueryParams
} from "../../urls";

export const COMBO_FILTERS_KEY = "comboFilters";

export function getFilterOpts(
  params: ComboListUrlFilters
): ComboListFilterOpts {
  return {
    enable: {
      active: params.enable !== undefined,
      value: maybe(() => parseBoolean(params.enable, true))
    },
    name: {
      active: !!maybe(() => params.name),
      value: params.name
    },
    products: {
      active: !!maybe(() => params.products),
      value: params.products
    }
  };
}

export function getFilterVariables(
  params: ComboListUrlFilters
): ComboFilterInput {
  return {
    enable:
      params.enable !== undefined
        ? parseBoolean(params.enable, false)
        : undefined,
    name: params.name,
    products: params.products,
    search: params.query
  };
}
export function getFilterQueryParam(
  filter: IFilterElement<ComboFilterKeys>
): ComboListUrlFilters {
  const { name } = filter;

  switch (name) {
    case ComboFilterKeys.name:
      return getSingleValueQueryParam(filter, ComboListUrlFiltersEnum.name);
    case ComboFilterKeys.products:
      return getSingleValueQueryParam(filter, ComboListUrlFiltersEnum.products);
    case ComboFilterKeys.enable:
      return getSingleValueQueryParam(filter, ComboFilterKeys.enable);
  }
}
export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<ComboListUrlFilters>(COMBO_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  ComboListUrlQueryParams,
  ComboListUrlFilters
>(ComboListUrlFiltersEnum);
